<!--非首页-->
<template>
  <el-container style="height: 100%">
    <el-header class="header" style="height:200px; padding: 0">
      <Header />
    </el-header>
    <el-container>
      <el-main class="route-main" :class="hiddenBg ? 'no-bg' : ''" :key="$route.path">
        <slot></slot>
      </el-main>
    </el-container>
    <Footer v-if="!hiddenFooter" />
  </el-container>
</template>
<script>
import Header from "./Header";
import Main from "./Main";
import Footer from "./Footer_pages";
import {
  getCookie,
  setCookie,
  removeCookie,
  getLoginUUId,
  getLoginUserId,
  getLoginRealName,
  getLoginUserName,
  getLoginUserUrl,
  getContentText,
} from "../plugins/cookie";
export default {
  name: "app",
  created() {
    // console.log(this.hiddenFooter);
  },
  components: {
    Header,
    Main,
    Footer,
  },
  methods: {},
  props: ["hiddenFooter","hiddenBg"],
};
</script>
<style lang="scss" scoped>
.route-main {
  padding: 0;
  background: url(~./../assets/images/inner_bg.jpg) no-repeat #e9eff6;
  background-size: 100% auto;
}
.no-bg{
  background-image: none;
}
.header {
  background: url(~./../assets/images/headbg.jpg) no-repeat right top;
  background-size:cover;
}
</style>
